document.addEventListener('DOMContentLoaded', function () {

  function initSwatchDrawer() {

    const swatchContainer = document.querySelector(
      '[option-name="Upholstery"]'
    );

    if (!swatchContainer) return;

    const swatchList = swatchContainer.querySelector(
      '.swatch-view-custom-image'
    );

    if (!swatchList) return;

    const items = swatchList.querySelectorAll(
      ':scope > .swatch-view-item'
    );

    if (items.length <= 4) return;

    /* DEBUG METAOBJECT DATA */

    console.group('FABRIC METAOBJECT INITIAL DATA');

    console.log('Fabric entries:', window.fabricInfoEntries);
    console.log('Is array:', Array.isArray(window.fabricInfoEntries));
    console.log(
      'Total entries:',
      window.fabricInfoEntries?.length || 0
    );

    console.groupEnd();

    /* CREATE MORE BUTTON */

    let moreBtn = swatchList.parentElement.querySelector(
      '.swatch-more-btn'
    );

    if (!moreBtn) {
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'swatch-more-btn';
      moreBtn.innerHTML = '+ more &gt;';
      swatchList.after(moreBtn);
    }

    /* CREATE SHARED OVERLAY */

    let overlay = document.querySelector(
      '.swatch-drawer-overlay'
    );

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'swatch-drawer-overlay';
      document.body.appendChild(overlay);
    }

    /* CREATE MAIN SWATCH DRAWER */

    let drawer = document.querySelector('.swatch-drawer');

    if (!drawer) {

      const vendorElement = document.querySelector(
        '.vendor.product-detail__gap-sm'
      );

      const vendor = vendorElement
        ? vendorElement.innerText.trim()
        : '';

      const vendorText = vendor.toLowerCase();

      let fabricLink = '/pages/bauhaus-studio-upholstery';

      if (vendorText.includes('mcm house')) {
        fabricLink = '/pages/mcm-house-swatches';
      } else if (vendorText.includes('bauhaus studio')) {
        fabricLink = '/pages/bauhaus-studio-upholstery';
      } else if (vendorText.includes('camerich')) {
        fabricLink = '/pages/camerich-upholstery';
      }

      drawer = document.createElement('div');
      drawer.className = 'swatch-drawer';

      drawer.innerHTML = `
        <div class="swatch-drawer-header">

          <div class="swatch-drawer-product-image-wrap">
            <img
              class="swatch-drawer-product-image"
              src=""
              alt=""
            >
          </div>

          <div class="swatch-drawer-title-wrap">
            <h3>
              Material
              <span id="choosed-color"></span>
            </h3>
            <p
              id="choosed-composition"
              class="swatch-drawer-composition"
              style="display:none;"
            ></p>
          </div>

          <button
            type="button"
            class="swatch-drawer-close"
            aria-label="Close drawer"
          >×</button>

        </div>

        <div class="swatch-drawer-grid"></div>

        <button
          type="button"
          class="swatch-drawer-confirm"
        >Confirm selection</button>

        <a
          target="_blank"
          rel="noopener noreferrer"
          href="${fabricLink}"
          class="swatch-drawer-confirm swatch-drawer-btn swatch-drawer-btn-secondary"
        >Can't find the right fabric? View more here.</a>

        <a
          target="_blank"
          rel="noopener noreferrer"
          href="/pages/fabric-composition"
          class="swatch-drawer-confirm swatch-drawer-btn swatch-drawer-btn-secondary"
        >More about sofa fabric compositions</a>
      `;

      document.body.appendChild(drawer);
    }

    /* UPGRADE OLD HEADER MARKUP (COMPOSITION INSIDE H3) */

    const oldComposition = drawer.querySelector(
      'h3 #choosed-composition'
    );

    if (oldComposition) {

      const oldHeading = oldComposition.closest('h3');

      const composition = document.createElement('p');
      composition.id = 'choosed-composition';
      composition.className = 'swatch-drawer-composition';
      composition.style.display = 'none';

      oldComposition.remove();
      oldHeading.insertAdjacentElement('afterend', composition);
    }

    /* COMPOSITION STYLES */

    if (!document.getElementById('swatch-composition-style')) {

      const style = document.createElement('style');
      style.id = 'swatch-composition-style';
      style.textContent = `
        .swatch-drawer-composition {
          display: block;
          width: 100%;
          margin: 6px 0 0;
          font-size: 14px;
          line-height: 1.4;
          color: #666;
        }
        .swatch-drawer-title-wrap {
          width: 100%;
        }
      `;
      document.head.appendChild(style);
    }

    const grid = drawer.querySelector('.swatch-drawer-grid');

    /* CREATE FABRIC INFORMATION DRAWER */

    let infoDrawer = document.querySelector(
      '.swatch-info-drawer'
    );

    if (!infoDrawer) {

      infoDrawer = document.createElement('div');
      infoDrawer.className = 'swatch-info-drawer';

      infoDrawer.innerHTML = `
        <div class="swatch-info-drawer-header">

          <h2 class="swatch-info-title"></h2>

          <button
            type="button"
            class="swatch-info-close"
            aria-label="Close fabric details"
          >×</button>

        </div>

        <div class="swatch-info-drawer-body">

          <div class="swatch-info-image-wrap">

            <img
              class="swatch-info-image"
              src=""
              alt=""
            >

            <div class="swatch-info-image-error">
              Image unavailable
            </div>

          </div>

          <div class="swatch-info-content">
            <div class="swatch-info-description"></div>
          </div>

        </div>
      `;

      document.body.appendChild(infoDrawer);
    }

    const infoImage = infoDrawer.querySelector(
      '.swatch-info-image'
    );

    const infoTitle = infoDrawer.querySelector(
      '.swatch-info-title'
    );

    const infoDescription = infoDrawer.querySelector(
      '.swatch-info-description'
    );

    const imageError = infoDrawer.querySelector(
      '.swatch-info-image-error'
    );

    /* NORMALIZE FABRIC NAME */

    function normalizeFabricName(name) {

      return String(name || '')
        .trim()
        .toLowerCase()
        .replace(/&amp;/g, '&')
        .replace(/&/g, 'and')
        .replace(/[^a-z0-9]/g, '');
    }

    /* GET FABRIC DETAILS FROM METAOBJECT */

    function getFabricDetails(swatchName) {

      const entries = window.fabricInfoEntries || [];

      console.group('FABRIC MATCH DEBUG');

      console.log('Selected swatch name:', swatchName);
      console.log('Total metaobject entries:', entries.length);

      if (!Array.isArray(entries) || !entries.length) {

        console.warn('No fabric metaobject entries available');

        console.groupEnd();

        return null;
      }

      const targetName = normalizeFabricName(swatchName);

      console.log('Normalized selected name:', targetName);

      const matchedEntry = entries.find(function(entry, index) {

        const entryName =
          entry.name ||
          entry.fabricName ||
          entry.fabric_name ||
          entry.title ||
          '';

        const normalizedEntryName =
          normalizeFabricName(entryName);

        console.log('Checking entry:', index);
        console.log('Entry name:', entryName);
        console.log('Normalized entry name:', normalizedEntryName);
        console.log(
          'Match:',
          normalizedEntryName === targetName
        );

        return normalizedEntryName === targetName;

      });

      if (matchedEntry) {

        console.log('SUCCESS: Fabric matched!');
        console.log('Matched fabric:', matchedEntry);
        console.log('Composition:', matchedEntry.composition);
        console.log('Description:', matchedEntry.descriptionHtml);
        console.log('Image:', matchedEntry.imageUrl);

      } else {

        console.warn('NO FABRIC MATCH FOUND:', swatchName);

        console.table(
          entries.map(function(entry) {
            return {
              name: entry.name,
              normalizedName: normalizeFabricName(entry.name)
            };
          })
        );
      }

      console.groupEnd();

      return matchedEntry || null;
    }

    /* GET SWATCH IMAGE URL */

    function getSwatchImage(item) {

      const imageElement = item.querySelector(
        '.star-set-image'
      );

      if (!imageElement) return '';

      const style =
        imageElement.getAttribute('style') || '';

      let match = style.match(
        /background-image\s*:\s*url\(\s*(['"]?)(.*?)\1\s*\)/i
      );

      if (!match) {

        const computedStyle = window.getComputedStyle(
          imageElement
        );

        match = computedStyle.backgroundImage.match(
          /url\(\s*(['"]?)(.*?)\1\s*\)/i
        );
      }

      return match && match[2]
        ? match[2].trim()
        : '';
    }

    /* GENERATE IMAGE URL CANDIDATES */

    function getImageCandidates(rawUrl) {

      const urls = [];

      function addUrl(url) {
        if (url && !urls.includes(url)) {
          urls.push(url);
        }
      }

      addUrl(rawUrl);

      try {
        addUrl(decodeURIComponent(rawUrl));
      } catch (error) {}

      try {
        addUrl(
          decodeURIComponent(
            decodeURIComponent(rawUrl)
          )
        );
      } catch (error) {}

      try {
        addUrl(
          encodeURI(
            decodeURIComponent(rawUrl)
          )
        );
      } catch (error) {}

      return urls;
    }

    /* LOAD IMAGE WITH FALLBACK */

    function loadSwatchImage(
      urls,
      index,
      swatchName,
      fallbackUrls
    ) {

      if (index >= urls.length) {

        if (fallbackUrls && fallbackUrls.length) {

          console.log('Trying original swatch image fallback');

          loadSwatchImage(
            fallbackUrls,
            0,
            swatchName,
            null
          );

          return;
        }

        infoImage.removeAttribute('src');
        infoImage.style.display = 'none';
        imageError.style.display = 'block';

        return;
      }

      const imageUrl = urls[index];

      console.log('Loading fabric image:', imageUrl);

      const testImage = new Image();

      testImage.onload = function() {

        console.log('Fabric image loaded:', imageUrl);

        infoImage.src = imageUrl;
        infoImage.alt = swatchName;
        infoImage.style.display = 'block';

        imageError.style.display = 'none';
      };

      testImage.onerror = function() {

        console.warn('Image failed:', imageUrl);

        loadSwatchImage(
          urls,
          index + 1,
          swatchName,
          fallbackUrls
        );
      };

      testImage.src = imageUrl;
    }

    /* READ COMPOSITION FROM METAOBJECT (STRING, LIST OR OBJECT) */

    function getComposition(fabricDetails) {

      if (!fabricDetails) return '';

      let raw =
        fabricDetails.composition ||
        fabricDetails.fabricComposition ||
        fabricDetails.fabric_composition ||
        (fabricDetails.fields && (
          fabricDetails.fields.composition ||
          fabricDetails.fields.fabric_composition
        )) ||
        '';

      if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
        raw = raw.value || raw.text || '';
      }

      if (typeof raw === 'string' && raw.trim().startsWith('[')) {
        try {
          raw = JSON.parse(raw);
        } catch (error) {}
      }

      if (Array.isArray(raw)) {
        raw = raw.filter(Boolean).join(', ');
      }

      raw = String(raw || '')
        .replace(/<[^>]*>/g, '')
        .trim();

      if (raw) return raw;

      /* FALLBACK: "Composition: ..." LINE INSIDE FABRIC INFORMATION */

      let info =
        fabricDetails.descriptionHtml ||
        fabricDetails.description_html ||
        fabricDetails.description ||
        fabricDetails.fabric_information ||
        fabricDetails.fabricInformation ||
        '';

      if (info && typeof info === 'object') {
        info = info.value || info.html || '';
      }

      if (typeof info !== 'string' || !info) return '';

      const text = info
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/(p|div|li|h[1-6])>/gi, '\n')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&');

      const match = text.match(/composition\s*:\s*([^\n\r]+)/i);

      return match ? match[1].trim() : '';
    }

    /* MAKE SURE COMPOSITION LINE EXISTS UNDER THE HEADING */

    function ensureCompositionElement() {

      const activeDrawer =
        document.querySelector('.swatch-drawer') || drawer;

      let el = activeDrawer.querySelector('#choosed-composition');

      const colorEl = activeDrawer.querySelector('#choosed-color');

      const heading = colorEl
        ? colorEl.closest('h1, h2, h3, h4, h5, h6, p, div')
        : activeDrawer.querySelector('h3');

      if (!heading) return el;

      if (!el || heading.contains(el)) {

        if (el) el.remove();

        el = document.createElement('p');
        el.id = 'choosed-composition';
        el.className = 'swatch-drawer-composition';

        heading.insertAdjacentElement('afterend', el);
      }

      return el;
    }

    /* UPDATE CHOSEN COLOUR AND COMPOSITION */

    function updateChosenColor(value) {

      const chosenColor = drawer.querySelector(
        '#choosed-color'
      );

      const chosenComposition = ensureCompositionElement();

      if (!value) return;

      console.group('UPDATE SELECTED FABRIC');

      console.log('Selected colour:', value);

      if (chosenColor) {
        chosenColor.textContent = value;
      }

      /* GET MATCHING FABRIC METAOBJECT */

      const fabricDetails = getFabricDetails(value);

      console.log('Matched fabric details:', fabricDetails);

      if (chosenComposition) {

        const composition = getComposition(fabricDetails);

        console.log('Composition value:', composition);

        if (composition) {

          chosenComposition.textContent =
            'Composition: ' + composition;

          chosenComposition.style.setProperty('display', 'block', 'important');

        } else {

          chosenComposition.textContent = '';

          chosenComposition.style.setProperty('display', 'none', 'important');

          console.warn(
            'Composition not available for:',
            value
          );
        }
      }

      console.groupEnd();
    }

    /* GET CURRENT SELECTED COLOUR */

    function getCurrentSelectedColor() {

      const selectedSwatch = swatchContainer.querySelector(
        '.swatch-variant-name'
      );

      if (selectedSwatch) {
        return selectedSwatch.innerText.trim();
      }

      const selectedItem = swatchList.querySelector(
        '.swatch-view-item.swatch-selected, .swatch-view-item.active'
      );

      return selectedItem
        ? selectedItem.getAttribute('orig-value')
        : '';
    }

    /* CLOSE ALL DRAWERS */

    function closeAllDrawers() {

      drawer.classList.remove('active');
      infoDrawer.classList.remove('active');
      overlay.classList.remove('active');

      document.body.style.overflow = '';
    }

    /* OPEN FABRIC INFORMATION DRAWER */

    function openInfoDrawer(item) {

      const swatchName =
        item.getAttribute('orig-value') ||
        item.getAttribute('aria-label') ||
        'Swatch details';

      console.group('OPEN FABRIC INFO DRAWER');

      console.log('Clicked swatch:', item);
      console.log('Swatch name:', swatchName);

      const rawSwatchImage = getSwatchImage(item);

      const fabricDetails = getFabricDetails(swatchName);

      console.log('Final matched fabric:', fabricDetails);

      infoTitle.textContent = swatchName;

      /* LOAD FABRIC DESCRIPTION */

      infoDescription.replaceChildren();

      let description = fabricDetails
        ? (
            fabricDetails.descriptionHtml ||
            fabricDetails.description_html ||
            fabricDetails.description ||
            ''
          )
        : '';

      console.log('Fabric description:', description);

      if (description) {

        if (typeof description === 'object') {

          description =
            description.value ||
            description.html ||
            '';
        }

        if (
          typeof description === 'string' &&
          description.trim()
        ) {

          const parser = new DOMParser();

          const parsedDescription = parser.parseFromString(
            description,
            'text/html'
          );

          infoDescription.replaceChildren(
            ...Array.from(parsedDescription.body.childNodes)
          );

          console.log('Description rendered successfully');

        } else {

          infoDescription.textContent =
            'More information about this fabric will be available soon.';
        }

      } else {

        infoDescription.textContent =
          'More information about this fabric will be available soon.';
      }

      /* RESET IMAGE */

      infoImage.removeAttribute('src');
      infoImage.style.display = 'none';
      imageError.style.display = 'none';

      /* ORIGINAL SWATCH IMAGE FALLBACK */

      const fallbackImages = rawSwatchImage
        ? getImageCandidates(rawSwatchImage)
        : [];

      /* METAOBJECT IMAGE */

      const metaobjectImage = fabricDetails
        ? (
            fabricDetails.imageUrl ||
            fabricDetails.image_url ||
            ''
          )
        : '';

      console.log('Metaobject image:', metaobjectImage);
      console.log('Fallback images:', fallbackImages);

      /* KEEP MAIN DRAWER OPEN */

      drawer.classList.add('active');

      /* OPEN INFO DRAWER ABOVE IT */

      infoDrawer.classList.add('active');
      overlay.classList.add('active');

      document.body.style.overflow = 'hidden';

      /* LOAD METAOBJECT IMAGE FIRST */

      if (
        typeof metaobjectImage === 'string' &&
        metaobjectImage.trim()
      ) {

        loadSwatchImage(
          getImageCandidates(metaobjectImage.trim()),
          0,
          swatchName,
          fallbackImages
        );

      } else if (fallbackImages.length) {

        loadSwatchImage(
          fallbackImages,
          0,
          swatchName,
          null
        );

      } else {

        imageError.style.display = 'block';
      }

      console.groupEnd();
    }

    /* CLOSE ONLY THE INFO DRAWER */

    function closeInfoDrawer() {

      infoDrawer.classList.remove('active');

      drawer.classList.add('active');
      overlay.classList.add('active');

      document.body.style.overflow = 'hidden';
    }

    /* SET PRODUCT IMAGE IN MAIN DRAWER */

    function setDrawerProductImage() {

      const firstCarouselImg = document.querySelector(
        '.custom-carousel__slides .custom-carousel__slide:first-child img'
      );

      /* UPDATE COLOUR AND COMPOSITION */

      updateChosenColor(getCurrentSelectedColor());

      const drawerImg = drawer.querySelector(
        '.swatch-drawer-product-image'
      );

      const drawerImgWrap = drawer.querySelector(
        '.swatch-drawer-product-image-wrap'
      );

      if (firstCarouselImg && drawerImg) {

        drawerImg.src =
          firstCarouselImg.currentSrc ||
          firstCarouselImg.src;

        drawerImg.alt =
          firstCarouselImg.alt || 'Product image';

        drawerImgWrap.style.display = 'block';

      } else {

        drawerImgWrap.style.display = 'none';
      }
    }

    /* OPEN MAIN SWATCH DRAWER */

    function openDrawer() {

      infoDrawer.classList.remove('active');

      grid.innerHTML = '';

      setDrawerProductImage();

      const latestItems = swatchList.querySelectorAll(
        ':scope > .swatch-view-item'
      );

      latestItems.forEach(function(item) {

        const clone = item.cloneNode(true);

        clone.style.display = 'block';

        const currentColor = getCurrentSelectedColor();

        if (
          currentColor &&
          normalizeFabricName(clone.getAttribute('orig-value')) ===
          normalizeFabricName(currentColor)
        ) {
          clone.classList.add('active');
        }

        /* CREATE MORE INFO BUTTON */

        const infoLink = document.createElement('button');

        infoLink.type = 'button';
        infoLink.className = 'swatch-more-info-link';
        infoLink.textContent = 'More info';

        infoLink.addEventListener('click', function(event) {

          event.preventDefault();
          event.stopPropagation();

          openInfoDrawer(item);
        });

        const imageWrapper = clone.querySelector(
          '.swatch-image-wrapper'
        );

        if (imageWrapper) {

          imageWrapper.insertAdjacentElement(
            'afterend',
            infoLink
          );

        } else {

          clone.appendChild(infoLink);
        }

        /* HANDLE SWATCH SELECTION */

        clone.addEventListener('click', function(event) {

          if (
            event.target.closest('.swatch-more-info-link')
          ) {
            return;
          }

          event.preventDefault();
          event.stopPropagation();

          const value = clone.getAttribute('orig-value');

          if (!value) return;

          console.log('Drawer swatch clicked:', value);

          const original = Array.from(
            swatchList.querySelectorAll(
              ':scope > .swatch-view-item'
            )
          ).find(function(swatch) {

            return normalizeFabricName(
              swatch.getAttribute('orig-value')
            ) === normalizeFabricName(value);
          });

          const originalSelector = original
            ? original.querySelector('.swatch-selector')
            : null;

          /* TRIGGER ORIGINAL SWATCH KING SELECTION */

          if (originalSelector) {

            console.log('Triggering original Swatch King selector');

            originalSelector.click();

          } else {

            console.warn('Original Swatch King selector not found');
          }

          /* UPDATE CHOSEN COLOUR AND COMPOSITION */

          updateChosenColor(value);

          /* UPDATE ACTIVE CLASS */

          grid
            .querySelectorAll('.swatch-view-item')
            .forEach(function(el) {
              el.classList.remove('active');
            });

          clone.classList.add('active');

          /* CHECK SELECTION AFTER APP UPDATE */

          setTimeout(function() {

            const selectedColor =
              getCurrentSelectedColor() || value;

            updateChosenColor(selectedColor);

          }, 300);

        });

        grid.appendChild(clone);
      });

      drawer.classList.add('active');
      overlay.classList.add('active');

      document.body.style.overflow = 'hidden';
    }

    /* CLOSE MAIN SWATCH DRAWER */

    function closeDrawer() {

      drawer.classList.remove('active');
      infoDrawer.classList.remove('active');
      overlay.classList.remove('active');

      document.body.style.overflow = '';
    }

    /* EVENT LISTENERS */

    if (!moreBtn.dataset.listenerAdded) {

      moreBtn.addEventListener('click', openDrawer); 

      moreBtn.dataset.listenerAdded = 'true';
    }

    if (!overlay.dataset.listenerAdded) {

      overlay.addEventListener('click', closeAllDrawers);

      overlay.dataset.listenerAdded = 'true';
    }

    if (!drawer.dataset.listenerAdded) {

      const closeButton = drawer.querySelector(
        '.swatch-drawer-close'
      );

      const confirmButton = drawer.querySelector(
        '.swatch-drawer-confirm'
      );

      if (closeButton) {
        closeButton.addEventListener('click', closeDrawer);
      }

      if (confirmButton) {
        confirmButton.addEventListener('click', closeDrawer);
      }

      drawer.dataset.listenerAdded = 'true';
    }

    if (!infoDrawer.dataset.listenerAdded) {

      const infoCloseButton = infoDrawer.querySelector(
        '.swatch-info-close'
      );

      if (infoCloseButton) {

        infoCloseButton.addEventListener(
          'click',
          closeInfoDrawer
        );
      }

      infoDrawer.dataset.listenerAdded = 'true';
    }

    /* ESCAPE KEY */

    if (!document.body.dataset.swatchEscapeReady) {

      document.addEventListener('keydown', function(event) {

        if (event.key === 'Escape') {

          if (infoDrawer.classList.contains('active')) {
            closeInfoDrawer();
          } else if (drawer.classList.contains('active')) {
            closeDrawer();
          }
        }
      });

      document.body.dataset.swatchEscapeReady = 'true';
    }
  }

  /* INITIALIZE */

  initSwatchDrawer();

  /* HANDLE DYNAMICALLY LOADED SWATCHES */

  let initTimeout;

  const observer = new MutationObserver(function() {

    clearTimeout(initTimeout);

    initTimeout = setTimeout(function() {
      initSwatchDrawer();
    }, 200);

  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});